/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Tooltip_Source1Inputs */

const id_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

const ms_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber`)
};

const da_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilde`)
};

const de_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle`)
};

const en_us2_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const es_es2_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

const es_mx2_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

const fil_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinagmulan`)
};

const fr_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const it_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const hu_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forrás`)
};

const nl_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bron`)
};

const no_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilde`)
};

const pl_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Źródło`)
};

const pt_br2_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const pt_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const ro_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sursă`)
};

const fi_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähde`)
};

const sv_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Källa`)
};

const vi_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nguồn`)
};

const tr_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaynak`)
};

const cs_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj`)
};

const bg_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Източник`)
};

const ru_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Источник`)
};

const uk_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Джерело`)
};

const ar_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المصدر`)
};

const hi_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत`)
};

const th_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แหล่งที่มา`)
};

const ja_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース`)
};

const zh_cn2_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来源`)
};

const zh_hant1_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`來源`)
};

const ko_offerdetail_tooltip_source1 = /** @type {(inputs: Offerdetail_Tooltip_Source1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출처`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Offerdetail_Tooltip_Source1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_tooltip_source1 = /** @type {((inputs?: Offerdetail_Tooltip_Source1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Tooltip_Source1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_tooltip_source1(inputs)
	if (locale === "ms") return ms_offerdetail_tooltip_source1(inputs)
	if (locale === "da") return da_offerdetail_tooltip_source1(inputs)
	if (locale === "de") return de_offerdetail_tooltip_source1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_tooltip_source1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_tooltip_source1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_tooltip_source1(inputs)
	if (locale === "fil") return fil_offerdetail_tooltip_source1(inputs)
	if (locale === "fr") return fr_offerdetail_tooltip_source1(inputs)
	if (locale === "it") return it_offerdetail_tooltip_source1(inputs)
	if (locale === "hu") return hu_offerdetail_tooltip_source1(inputs)
	if (locale === "nl") return nl_offerdetail_tooltip_source1(inputs)
	if (locale === "no") return no_offerdetail_tooltip_source1(inputs)
	if (locale === "pl") return pl_offerdetail_tooltip_source1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_tooltip_source1(inputs)
	if (locale === "pt") return pt_offerdetail_tooltip_source1(inputs)
	if (locale === "ro") return ro_offerdetail_tooltip_source1(inputs)
	if (locale === "fi") return fi_offerdetail_tooltip_source1(inputs)
	if (locale === "sv") return sv_offerdetail_tooltip_source1(inputs)
	if (locale === "vi") return vi_offerdetail_tooltip_source1(inputs)
	if (locale === "tr") return tr_offerdetail_tooltip_source1(inputs)
	if (locale === "cs") return cs_offerdetail_tooltip_source1(inputs)
	if (locale === "bg") return bg_offerdetail_tooltip_source1(inputs)
	if (locale === "ru") return ru_offerdetail_tooltip_source1(inputs)
	if (locale === "uk") return uk_offerdetail_tooltip_source1(inputs)
	if (locale === "ar") return ar_offerdetail_tooltip_source1(inputs)
	if (locale === "hi") return hi_offerdetail_tooltip_source1(inputs)
	if (locale === "th") return th_offerdetail_tooltip_source1(inputs)
	if (locale === "ja") return ja_offerdetail_tooltip_source1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_tooltip_source1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_tooltip_source1(inputs)
	return ko_offerdetail_tooltip_source1(inputs)
});
export { offerdetail_tooltip_source1 as "offerDetail.tooltip.source" }